export default "/images/SL_mecanique.png?cb3a8aad298c006e81fb4577ce58b9dd";